<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-cart-arrow-down"></i> Purchases</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <strong>Purchases</strong>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                        <template v-if="component == 'pocheckout'">
                            <router-link :to="{name: 'purchases'}" class="btn btn-secondary waves-effect waves-light text-white">
                                <i class="fas fa-arrow-left"></i>&nbsp; Back
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "PurchasesLayout",
        data() {
            return {
                component: null
            }
        },
        watch: {
            $route(to, from) {
                this.component = to.name;
            }
        },
        created() {
            this.component = this.$route.name;
        }
    }
</script>

<style scoped>

</style>
